import styled from 'styled-components'
import { Shell } from '../../Components/Card'

export const Container = styled(Shell)`
  margin-top: 4rem;
  padding: 24px;
  gap: 24px;
  display: grid;

  @media (min-width: 1200px) {
    grid-template-columns: 1fr 5fr;
  }
`
